import axios from 'axios';

const prefix = '/sellerFulfillmentProvider';

export const updateSellerFulfillmentProviderSettings = (sellerFulfillmentProviderId, settings) =>
  axios.put(`${prefix}/${sellerFulfillmentProviderId}`, settings);
